import type { EeocSection } from "~/types/jben/job_post";
import EeocFormSection from "~/components/job_posts/eeoc/form_section";
import "./form.scss";
import type { FieldValue } from "../field";

interface Props {
  answers: Record<string, FieldValue>;
  sections: EeocSection[];
  errors: Record<string, string>;
  onChange: (key: string, value: FieldValue) => void;
}

export const EeocForm = ({ answers, sections, errors, onChange }: Props) => {
  return (
    <div className="eeoc__container body">
      <div className="divider" role="separator"></div>

      {sections.map((section, i) => (
        <EeocFormSection
          key={i}
          section={section}
          errors={errors}
          onChange={onChange}
          answers={answers}
        />
      ))}
    </div>
  );
};
